import React, { useEffect } from 'react';

import Box from '@mui/material/Box';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Button from '@mui/material/Button';

import sha512 from 'js-sha512';



let server_url = 'https://mapi2.newsy.today';
//let server_url = 'http://127.0.0.1:3404';




function SignUp (){


    const [Status,setStatus] = React.useState();



    useEffect(()=>{
 
        console.log('Signup');
        
    
      });


      async function signup_user(dataObject){
  
  
        return new Promise(function (resolve,reject){

          try{

                    /*
                    const token = localStorage.getItem('AccessToken'); 
                    let options = {
                      headers: {
                        'Authorization': 'Bearer ' + token,
                        'Content-Type': 'application/json'
                      },
                      insecure: true,
                      rejectUnauthorized: false
                    }

                    let myheaders = {
                      'Authorization': 'Bearer ' + token,
                      'Content-Type': 'application/json'
                    };
                    */

                    let myheaders = {
                      'Content-Type': 'application/json'
                    };

                      
            
                      fetch(server_url + "/create_user",{
                        method: 'POST',
                        //headers: { 'Content-Type': 'application/json' },
                        headers: myheaders,
                        body: JSON.stringify(dataObject)
                        })
                          .then(response => response.json())
                          .then(function(data){
                                  console.log('xxx');
                                  console.log(data);
                                  console.log('xxx2');
                                  resolve(data);
                               
                          
                          });
          }
          catch(err){
                  console.log(err);
                  reject(err);
          }

          })




      }
    


    return(


      <Box sx={{ '& > :not(style)': { m: 1 } }}>
      <FormControl variant="standard">


      <div>
        <TextField
          label="UserName"
          id="username"
          defaultValue=""
          size="small"
          margin="dense"
        />
      </div>
          

      <div>
        <TextField
          label="Password"
          id="password"
          type="password"
          defaultValue=""
          size="small"
          margin="dense"
        />
       
      </div>
       
      <div>
        <TextField
          label="Email"
          id="email"
          defaultValue=""
          size="small"
          margin="dense"
        />
       
      </div>


       
   


      <div>
      <Button variant="text" onClick={async ()=>{

            let username = document.getElementById('username').value;
            let password = document.getElementById('password').value;
            let email = document.getElementById('email').value;
       
            let hashed_pass = sha512(password);


            let jsonData = {
              username: username,
              password: hashed_pass,
              email: email
            }

            console.log(jsonData);
            let res = await signup_user(jsonData);
            if(res.status === 'OK'){
                setStatus('User Created');
            }
            else{
                setStatus(res.status);
            }



      }}>Signup</Button>

       
      </div>
      <div>{Status}</div>



          
          
        </FormControl>    
 

    </Box>



    );
   }
    
   export default SignUp;